import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyTheyFail() {
  const cards = [{
    title: 'ANTIBIÓTICOS SOLOS',
    desc: 'Los tomás, mejorás 3 semanas y el SIBO vuelve. Sin resolver la causa, siempre vuelve.'
  }, {
    title: 'DIETA SIN GLUTEN O SIN LACTOSA',
    desc: 'Eliminar un alimento no es resolver el problema. El sobrecrecimiento sigue activo.'
  }, {
    title: 'PROBIÓTICOS DEL SUPERMERCADO',
    desc: 'En Fase 1 del SIBO, los probióticos agregan bacterias a un intestino ya sobrepoblado. Empeoran el cuadro.'
  }, {
    title: 'GUÍAS DE FODMAP IMPORTADAS',
    desc: 'Diseñadas para mercados europeos o australianos. Ingredientes que en Argentina no existen o cuestan una fortuna.'
  }, {
    title: 'LA NUTRICIONISTA TRADICIONAL',
    desc: 'El plan funciona mientras pagás el seguimiento. Cuando termina, los síntomas vuelven porque las causas nunca se resolvieron.'
  }];
  return <section className="bg-forest-50 py-20 px-4" data-id="element-260">
      <div className="max-w-5xl mx-auto" data-id="element-261">
        <h2 className="text-3xl md:text-4xl font-bold text-forest-900 text-center mb-12" data-id="element-262">
          Ya lo intentaste todo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-263">
          {cards.map((card, idx) => <div key={idx} className="bg-white p-8 rounded-2xl border-t-4 border-pain shadow-lg" data-id="element-264">
              <div className="flex items-center space-x-3 mb-4" data-id="element-265">
                <XCircle className="w-6 h-6 text-pain flex-shrink-0" data-id="element-266" />
                <h4 className="text-xl font-bold text-forest-900" data-id="element-267">
                  {card.title}
                </h4>
              </div>
              <p className="text-forest-800 text-lg" data-id="element-268">{card.desc}</p>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-269">
          <p className="text-xl md:text-2xl text-forest-800 font-medium" data-id="element-270">
            Todas te piden que luches contra tu cuerpo.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-forest-900 mt-2" data-id="element-271">
            El Protocolo Rescate SIBO™ hace lo opuesto.
          </p>
        </div>
      </div>
    </section>;
}